import React from "react";
import "./ViewToggle.scss";
import { useDispatch, useSelector } from "react-redux";
import { setViewMode } from "../../store/feature/ViewSlice";
import CustomHtmlTooltip from "../../helpers/CustomHtmlTooltip";

function GridIcon({ className, ...props }: { className?: string; [key: string]: any }) {
  return (
    <svg 
      width="16" 
      height="16" 
      viewBox="0 0 16 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path 
        d="M2.5 6.99998C2.36739 6.99998 2.24021 6.9473 2.14645 6.85353C2.05268 6.75976 2 6.63259 2 6.49998V2.50098C2 2.36837 2.05268 2.24119 2.14645 2.14742C2.24021 2.05366 2.36739 2.00098 2.5 2.00098H6.5C6.63261 2.00098 6.75979 2.05366 6.85355 2.14742C6.94732 2.24119 7 2.36837 7 2.50098V6.49998C7 6.63259 6.94732 6.75976 6.85355 6.85353C6.75979 6.9473 6.63261 6.99998 6.5 6.99998H2.5ZM9.5 6.99998C9.36739 6.99998 9.24021 6.9473 9.14645 6.85353C9.05268 6.75976 9 6.63259 9 6.49998V2.50098C9 2.36837 9.05268 2.24119 9.14645 2.14742C9.24021 2.05366 9.36739 2.00098 9.5 2.00098H13.499C13.6316 2.00098 13.7588 2.05366 13.8526 2.14742C13.9463 2.24119 13.999 2.36837 13.999 2.50098V6.49998C13.999 6.63259 13.9463 6.75976 13.8526 6.85353C13.7588 6.9473 13.6316 6.99998 13.499 6.99998H9.5ZM2.5 14C2.36739 14 2.24021 13.9473 2.14645 13.8535C2.05268 13.7598 2 13.6326 2 13.5V9.49998C2 9.36737 2.05268 9.24019 2.14645 9.14642C2.24021 9.05265 2.36739 8.99998 2.5 8.99998H6.5C6.63261 8.99998 6.75979 9.05265 6.85355 9.14642C6.94732 9.24019 7 9.36737 7 9.49998V13.5C7 13.6326 6.94732 13.7598 6.85355 13.8535C6.75979 13.9473 6.63261 14 6.5 14H2.5ZM9.5 14C9.36739 14 9.24021 13.9473 9.14645 13.8535C9.05268 13.7598 9 13.6326 9 13.5V9.49998C9 9.36737 9.05268 9.24019 9.14645 9.14642C9.24021 9.05265 9.36739 8.99998 9.5 8.99998H13.499C13.6316 8.99998 13.7588 9.05265 13.8526 9.14642C13.9463 9.24019 13.999 9.36737 13.999 9.49998V13.5C13.999 13.6326 13.9463 13.7598 13.8526 13.8535C13.7588 13.9473 13.6316 14 13.499 14H9.5Z" 
        fill="currentColor"
      />
    </svg>
  );
}

function ListIcon({ className, ...props }: { className?: string; [key: string]: any }) {
  return (
    <svg 
      width="18" 
      height="18" 
      viewBox="0 0 18 18" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path 
        d="M2.625 5.28125C3.04769 5.28125 3.45307 5.11334 3.75195 4.81445C4.05084 4.51557 4.21875 4.11019 4.21875 3.6875C4.21875 3.26481 4.05084 2.85943 3.75195 2.56055C3.45307 2.26166 3.04769 2.09375 2.625 2.09375C2.20231 2.09375 1.79693 2.26166 1.49805 2.56055C1.19916 2.85943 1.03125 3.26481 1.03125 3.6875C1.03125 4.11019 1.19916 4.51557 1.49805 4.81445C1.79693 5.11334 2.20231 5.28125 2.625 5.28125ZM6.875 2.625C6.2873 2.625 5.8125 3.0998 5.8125 3.6875C5.8125 4.2752 6.2873 4.75 6.875 4.75H16.4375C17.0252 4.75 17.5 4.2752 17.5 3.6875C17.5 3.0998 17.0252 2.625 16.4375 2.625H6.875ZM6.875 7.9375C6.2873 7.9375 5.8125 8.4123 5.8125 9C5.8125 9.5877 6.2873 10.0625 6.875 10.0625H16.4375C17.0252 10.0625 17.5 9.5877 17.5 9C17.5 8.4123 17.0252 7.9375 16.4375 7.9375H6.875ZM6.875 13.25C6.2873 13.25 5.8125 13.7248 5.8125 14.3125C5.8125 14.9002 6.2873 15.375 6.875 15.375H16.4375C17.0252 15.375 17.5 14.9002 17.5 14.3125C17.5 13.7248 17.0252 13.25 16.4375 13.25H6.875ZM2.625 15.9062C3.04769 15.9062 3.45307 15.7383 3.75195 15.4395C4.05084 15.1406 4.21875 14.7352 4.21875 14.3125C4.21875 13.8898 4.05084 13.4844 3.75195 13.1855C3.45307 12.8867 3.04769 12.7188 2.625 12.7188C2.20231 12.7188 1.79693 12.8867 1.49805 13.1855C1.19916 13.4844 1.03125 13.8898 1.03125 14.3125C1.03125 14.7352 1.19916 15.1406 1.49805 15.4395C1.79693 15.7383 2.20231 15.9062 2.625 15.9062ZM4.21875 9C4.21875 8.79071 4.17753 8.58346 4.09743 8.3901C4.01734 8.19674 3.89994 8.02104 3.75195 7.87305C3.60396 7.72506 3.42826 7.60766 3.2349 7.52757C3.04154 7.44747 2.83429 7.40625 2.625 7.40625C2.41571 7.40625 2.20846 7.44747 2.0151 7.52757C1.82174 7.60766 1.64604 7.72506 1.49805 7.87305C1.35006 8.02104 1.23266 8.19674 1.15257 8.3901C1.07247 8.58346 1.03125 8.79071 1.03125 9C1.03125 9.20929 1.07247 9.41654 1.15257 9.6099C1.23266 9.80326 1.35006 9.97896 1.49805 10.127C1.64604 10.2749 1.82174 10.3923 2.0151 10.4724C2.20846 10.5525 2.41571 10.5938 2.625 10.5938C2.83429 10.5938 3.04154 10.5525 3.2349 10.4724C3.42826 10.3923 3.60396 10.2749 3.75195 10.127C3.89994 9.97896 4.01734 9.80326 4.09743 9.6099C4.17753 9.41654 4.21875 9.20929 4.21875 9Z" 
        fill="currentColor"
      />
    </svg>
  );
}

export type ViewMode = "grid" | "list";

interface ViewToggleProps {
  className?: string;
}

const ViewToggle: React.FC<ViewToggleProps> = ({
  className,
}) => {
  const viewMode = useSelector((state: any) => state.view.viewMode);
  const dispatch = useDispatch();

  const handleGridClick = () => {
    if (viewMode !== "grid") {
      dispatch(setViewMode("grid"));
    }
  };

  const handleListClick = () => {
    if (viewMode !== "list") {
      dispatch(setViewMode("list"));
    }
  };

  return (
    <div 
        className={`${className ?? ''} view-toggle`}
    >
      
      <CustomHtmlTooltip title="Grid view" placement="bottom" arrow>
      <div
        onClick={handleGridClick}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleGridClick();
          }
        }}
        role="button"
        className={`view-toggle__button ${viewMode === "grid" ? "view-toggle__button--active" : ""}`}
        aria-label="Grid view"
        aria-pressed={viewMode === "grid"}
      >
        <GridIcon className="view-toggle__icon" />
      

      </div>
      </CustomHtmlTooltip>
      
      <div className="view-toggle__divider" />
      
      <CustomHtmlTooltip title="List view" placement="bottom" arrow>
      <div
        onClick={handleListClick}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleListClick();
          }
        }}
        role="button"
        className={`view-toggle__button ${viewMode === "list" ? "view-toggle__button--active" : ""}`}
        aria-label="List view"
        aria-pressed={viewMode === "list"}
      >
        <ListIcon className="view-toggle__icon" />
       
      </div>
      </CustomHtmlTooltip>
    </div>
  );
};

export default ViewToggle;